import React from "react";
import { REGISTRATION_URL, SITE } from "@/lib/config";

export default function StickyMobileCTA() {
    return (
        <div
            data-testid="sticky-mobile-cta"
            className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white border-t border-[#E2E4E9] px-3 pt-3"
            style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
            <a
                href={REGISTRATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="btn-hazte-socio-sticky"
                className="block w-full bg-[#082050] text-white text-center py-3.5 text-sm font-medium"
            >
                Hazte socio · {SITE.quota}
            </a>
        </div>
    );
}
